module.exports = __webpack_public_path__ + "static/media/getrouteicon.ded6480b.svg";